<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <validation-observer ref="observer" v-slot="{ invalid, handleSubmit }">
          <b-form @submit.prevent="">
            <div class="form-card-wrapper">
              <b-card header-tag="header">
                <template #header>
                  <b>Contenuto</b>
                </template>
                <b-card-text>
                  <b-row
                    class="mb-2"
                    style="padding-right: 15px; padding-left: 15px"
                  >
                    <div class="form-group">
                      <base-input
                        name="title"
                        vid="title"
                        label="Titolo"
                        v-model="form[rep].title"
                        placeholder="Inserisci un titolo"
                        :rules="{ required: true }"
                      />
                    </div>
                    <div class="form-group">
                      <base-select
                        name="type"
                        label="Tipo"
                        v-model="form[rep].type"
                        :options="types"
                        :taggable="false"
                        :multiple="false"
                        :rules="{ required: true }"
                      />
                    </div>
                  </b-row>
                  <div class="form-group col-md-12">
                    <base-input
                      name="subject"
                      vid="subject"
                      label="Oggetto Email"
                      maxlength="500"
                      v-model="form[rep].subject"
                      placeholder="Inserisci oggetto email"
                      :rules="{ required: true }"
                    />
                  </div>
                  <div class="col-md-12">
                    <label>Testo Email:</label>
                    <base-editor
                      editor_id="email_text"
                      :height="500"
                      :image_list="images"
                      v-model="form[rep].text"
                      :isEdit="true"
                      @onInitEditEditor="onInitEditEditor"
                      @updateEditorContent="updateEditorContent"
                    />
                  </div>
                </b-card-text>
              </b-card>
            </div>
            <div class="form-actions form-actions--sticky">
              <div class="inner-wrapper">
                <div>
                  <span
                    :title="`${
                      invalid
                        ? 'Compila correttamente i campi per poter salvare'
                        : 'Invia il form'
                    }`"
                  >
                    <b-button
                      @click="handleSubmit(onSubmit)"
                      type="button"
                      :disabled="invalid"
                      variant="lisaweb"
                      size="sm"
                    >
                      Salva
                    </b-button>
                  </span>
                  <b-button
                    type="button"
                    variant="lisaweb"
                    size="sm"
                    @click="showEmailPreview"
                  >
                    Preview
                  </b-button>
                  <b-button
                    type="button"
                    variant="lisaweb"
                    size="sm"
                    @click="onDuplicate"
                    title="Duplica template"
                  >
                    <b-icon icon="files"></b-icon> Duplica
                  </b-button>
                </div>
                <div>
                  <b-button
                    @click="$router.back()"
                    size="sm"
                    class="btn--transparent"
                    title="Torna alla pagina precedente"
                  >
                    <b-icon-chevron-double-left
                      font-scale="0.9"
                    ></b-icon-chevron-double-left>
                    Torna indietro
                  </b-button>
                </div>
              </div>
            </div>
          </b-form>
        </validation-observer>
        <email-preview-modal
          :subject="form[rep].subject"
          :email="form[rep].text"
        >
        </email-preview-modal>
        <duplicate-lisacomunica-template-modal
          :id="duplicateModalId"
          :repository="repository"
          :item="duplicateItem"
          :type-label="typeLabel"
          @duplicated="onDuplicated"
        />
      </div>
      <template #overlay>
        <div class="text-center mt-5">
          <base-icon name="loading" width="35" height="35" />
          <p id="cancel-label">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
    <div class="is-saving-template" v-show="isSavingTemplate"></div>
  </div>
</template>

<script>
import ShortcutMixin from "@/mixins/ShortcutMixin";
import LisaComunicaMixin from "@/mixins/LisaComunicaMixin";
import BaseIcon from "@/components/BaseIcon";
import BaseSelect from "@/components/form/BaseSelect";
import BaseInput from "@/components/form/BaseInput";
import BaseEditor from "@/components/form/BaseEditor";
import EmailPreviewModal from "@/components/modals/emailPreviewModal";
import DuplicateLisacomunicaTemplateModal from "@/components/modals/duplicateLisacomunicaTemplateModal";

export default {
  mixins: [ShortcutMixin, LisaComunicaMixin],
  data() {
    return {
      repository: "email",
      typeLabel: "Email",
      duplicateModalId: "duplicateEmailEditModal",
      duplicateItem: {},
      isLoading: true,
      isSavingTemplate: false,
      id: this.$route.params.id,
      types: [
        { value: "AVV_SCAD", text: "Avvisi scadenza" },
        { value: "MKTG", text: "Marketing" },
        { value: "SOLL", text: "Solleciti" },
        { value: "REN_PRO", text: "Rendiconti" },
      ],
      images: [],
      form: {
        email: {
          title: null,
          type: null,
          subject: null,
          text: null,
        },
      },
      original_value: null,
      updated_content: null,
      table_row_item: this.$route.params.item ? this.$route.params.item : {},
    };
  },
  components: {
    BaseIcon,
    BaseInput,
    BaseSelect,
    BaseEditor,
    EmailPreviewModal,
    DuplicateLisacomunicaTemplateModal,
  },
  methods: {
    updateEditorContent(contentHtml) {
      console.log("contentHtml", contentHtml);
      this.updated_content = contentHtml;
    },
    onInitEditEditor() {
      console.log("onInitEditEditor");
      setTimeout(() => {
        this.form[this.rep].text = this.original_value;
      }, 300);
    },
    onDuplicate() {
      this.duplicateItem = { id: this.id, title: this.form[this.rep].title };
      this.$bvModal.show(this.duplicateModalId);
    },
    onDuplicated() {
      // /new non restituisce l'id del nuovo template: torniamo all'elenco
      this.shortcut("lisacomunica_template", null, "#Email", "filterEmail");
    },
    onSubmit() {
      // if (
      //   !this.updated_content ||
      //   this.updated_content === `<p><br data-mce-bogus="1"></p>` ||
      //   this.updated_content === `<p></p>`
      // ) {
      //   this.updated_content = this.original_value;
      // }
      // this.form[this.rep].text = this.updated_content;
      this.form[this.rep].text = this.get_html_from_iframe("email_text");
      if (
        !this.form[this.rep].text ||
        this.form[this.rep].text === `<p><br data-mce-bogus="1"></p>` ||
        this.form[this.rep].text === `<p></p>`
      ) {
        this.$showSnackbar({
          preset: "error",
          text: `C'è stato un problema durante il salvataggio. Ti preghiamo di riprovare più tardi.`,
        });
        return;
      }
      this.isSavingTemplate = true;
      this.update()
        .then(() => {
          this.isSavingTemplate = false;
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Template Email Modificato`,
          });
          this.shortcut("lisacomunica_template", null, "#Email", "filterEmail");
        })
        .catch((error) => {
          let errMsg =
            error?.response?.data?.message || this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isSavingTemplate = false;
        });
    },
  },
  created() {
    this.show()
      .then((response) => {
        this.initializeEditForm(response.data.content);
        this.original_value =
          this.form[this.rep].text ?? this.table_row_item?.text;
        this.form[this.rep].text = "";
        this.index("", "image")
          .then((response) => {
            this.setImages(response.data.content);
            this.isLoading = false;
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({
              preset: "error",
              text: `${errMsg}`,
            });
            this.isLoading = false;
          });
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({
          preset: "error",
          text: `${errMsg}`,
        });
        this.isLoading = false;
        this.ok = true;
      });
  },
  computed: {
    rep() {
      return this.repository;
    },
  },
};
</script>
